import React from 'react';
import HeroSection from './components/HeroSection';
import WhoWeAre from './components/WhoWeAre';
import ServicesSection from './components/ServicesSection';
import StrongerTomorrowSection from './components/StrongerTomorrowSection';
import BuiltOnInnovationSection from './components/BuiltOnInnovationSection';
import VisionToRealitySection from './components/VisionToRealitySection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import FactsAndFiguresSection from './components/FactsAndFiguresSection';
import OurClientsSection from './components/OurClientsSection';
import AwardsRecognitionSection from './components/AwardsRecognitionSection';
import BlogSection from './components/BlogSection';
import ContactUsSection from './components/ContactUsSection';
import FooterSection from './components/FooterSection';

import AboutUs from './pages/AboutUs';
import ServicesPage from './pages/Services';
import BlogsPage from './pages/Blogs';

function useScrollAnimations() {
  React.useEffect(() => {
    const els = document.querySelectorAll('.section-animate');
    if (els.length === 0) return;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { root: null, rootMargin: '0px 0px -60px 0px', threshold: 0.08 }
    );
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

function HomePage() {
  return (
    <div className="figma-viewport">
      <div className="section-animate"><HeroSection /></div>
      <div className="section-animate"><WhoWeAre /></div>
      <div className="section-animate"><ServicesSection /></div>
      <div className="section-animate"><StrongerTomorrowSection /></div>
      <div className="section-animate"><BuiltOnInnovationSection /></div>
      <div className="section-animate"><VisionToRealitySection /></div>
      <div className="section-animate"><WhyChooseUsSection /></div>
      <div className="section-animate"><FactsAndFiguresSection /></div>
      <div className="section-animate"><OurClientsSection /></div>
      <div className="section-animate"><AwardsRecognitionSection /></div>
      <div className="section-animate"><BlogSection /></div>
      <div className="section-animate"><ContactUsSection /></div>
      <div className="section-animate"><FooterSection /></div>
    </div>
  );
}

function App() {
  useScrollAnimations();
  const path = window.location.pathname;
  const hash = window.location.hash;
  const isAbout = path === '/about' || path === '/about/';
  const isServices = path === '/services' || path === '/services/';
  const isBlogs = path === '/blogs' || path === '/blogs/' || hash === '#blogs';

  if (isAbout) return <AboutUs />;
  if (isServices) return <ServicesPage />;
  if (isBlogs) return <BlogsPage />;
  return <HomePage />;
}

export default App;

